import React, { useRef } from "react";
import { history } from "@helpers/history";
import { useDispatch } from "react-redux";
import * as FindBarActions from "app/@Base/components/FindBar/store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";
import "./FindBar.css";
import IconoBusqueda from "./../../../../assets/img/search/Icono Busqueda.png";

function FindBar({ showInMobile, handleClose, ...props }) {
  const dispatch = useDispatch();
  const searchInput = useRef(null);
  const isMidLaptop = useMediaQuery("(min-width: 1280px)");

  const handleSearch = () => {
    dispatch(FindBarActions.setLastSearchCriteria(searchInput.current.value));
    history.push("/buscar");
    showInMobile && handleClose();
  };

  // Findbar component
  const FBarra = () => (
    <div className="d-flex justify-content-between">
      {!showInMobile ? <div className="lblbuscar">Buscar</div> : null}
      <div style={showInMobile && { width: "100%" }}>
        <input
          id="searchInput"
          ref={searchInput}
          className={`form-control ${
            showInMobile ? "searchbox-mobile" : "searchbox"
          }`}
          type="text"
          aria-label="Buscar"
          placeholder={showInMobile ? "Buscar" : ""}
        />
      </div>
      <img
        className={`${showInMobile ? "searchBtn-mobile" : "searchBtn"}`}
        key={0}
        src={IconoBusqueda}
        alt="Buscar"
        onClick={handleSearch}
      />
    </div>
  );

  return isMidLaptop ? <FBarra /> : showInMobile ? <FBarra /> : null;
}

export default FindBar;
